import React from 'react'
import { Box, ClickAwayListener, IconButton, Popper, SxProps, Typography } from '@mui/material'
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined'

export default function DefinitionsRoleIconPopper() {

  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null)

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(anchorEl ? null : event.currentTarget)
  }

  const open = Boolean(anchorEl)
  const id = open ? 'simple-popper' : undefined

  return (
    <>
      <IconButton onClick={handleClick}>
        <InfoOutlinedIcon fontSize='small' />
      </IconButton>

      <Popper id={id} open={open} anchorEl={anchorEl} sx={sxPopper}>
        <ClickAwayListener onClickAway={() => setAnchorEl(null)}>
          <Box sx={{ border: 1, p: 3, bgcolor: 'background.paper' }} onClick={handleClick}>
            <Typography variant='h5'>Role</Typography>

            <Typography><b>Admin: </b> Handles role assignments, plan selection, and billing contacts.</Typography>
            <Typography><b>Member: </b> Standard feature access.</Typography>
            <Typography><b>Inactive: </b> Access disabled, plan marked as Expired.</Typography>
          </Box>
        </ClickAwayListener>
      </Popper>
    </>
  )
}

const sxPopper: SxProps = {
  zIndex: 1500,
}